import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getSetupPlan,
  putSetupPlanSection,
} from "@/lib/api/clients/EventSetupPlanClient";
import { qk } from "@/lib/query/queryKeys";
import { SetupSectionKey, SetupSectionUpdate } from "@/types/SetupPlan";

/**
 * Setup-journey hooks wrap the throwing CLIENT layer directly (like
 * useEventGoals). `data === null` means the event has NO plan (pre-feature
 * event) — a distinct, non-error state callers use to redirect.
 */

export function useSetupPlan(eventId: string | null) {
  return useQuery({
    queryKey: eventId ? qk.setupPlan.doc(eventId) : ["setup-plan", "none"],
    queryFn: () => getSetupPlan(eventId!),
    enabled: !!eventId,
    staleTime: 30_000,
  });
}

export function useUpdateSetupSection(eventId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ key, update }: { key: SetupSectionKey; update: SetupSectionUpdate }) =>
      putSetupPlanSection(eventId, key, update),
    onSuccess: (stored) => {
      queryClient.setQueryData(qk.setupPlan.doc(eventId), stored);
    },
  });
}
